import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { MenuItem } from '@mui/material';

export const StyledVoiceCloningHome = styled('div')`
  border-radius: 16px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  background-color: ${COLOR.white};
  gap: 24px;
`;

export const StyledHeader = styled('div')`
  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .divider {
    margin-top: 24px;
    border-color: ${COLOR.darkV2[16]};
  }
`;

export const StyledContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StyledVoiceCloningOptionWrapper = styled('div')`
  width: 100%;
  display: flex;
  min-height: 288px;
  gap: 24px;
`;

export const StyledVoiceCloningOption = styled('div')`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: ${(props) =>
    props.isProVoiceCloning ? COLOR.gradient : COLOR.charcoalV2[64]};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 16px 0 ${COLOR.black[8]};
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 1;

  @media only screen and (max-width: 1024px) {
    ${(props) => props?.mobileHeight && `height: ${props?.mobileHeight}px`};
  }

  ${(props) =>
    props.isProVoiceCloning
      ? `
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 16px;
      padding: 2px;
      background: ${COLOR.gradient};
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: 0;
    }
    background-clip: padding-box;
    border: 1px solid ${COLOR.pink[8]};
    `
      : `border: 1px solid ${COLOR.darkV2[16]};`}

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon-container {
      box-sizing: border-box;
      width: 48px;
      height: 48px;
      border-radius: 12px;
      padding: 8px;
      background-color: ${COLOR.whiteV2.default};
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 2px 16px 0px ${COLOR.black[8]};

      .icon {
        color: ${COLOR.indigo.default};
        width: 32px;
        height: 32px;
      }
    }

    .badge-wrapper {
      border-radius: 480px;
      padding: 8px 12px;
      background: ${(props) =>
        props.isProVoiceCloning
          ? 'linear-gradient(100.92deg, rgba(244, 139, 113, 0.08) -15.23%, rgba(241, 65, 77, 0.08) 42.62%, rgba(86, 62, 250, 0.08) 99.91%)'
          : COLOR.indigo[8]};
      position: relative;

      span {
        position: relative;
        z-index: 1;
        background: ${(props) =>
          props.isProVoiceCloning ? COLOR.rainbow : COLOR.indigo.default};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
  }

  .description-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .label-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .action-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .upgrade-package-action-wrapper {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 12px 16px;
    justify-content: space-between;
    background-color: ${COLOR.secondary[40]};

    .upgrade-package-desc {
      display: flex;
      gap: 8px;
      align-items: center;

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          width: 24px;
          height: 24px;
          color: ${COLOR.secondary[8]};
        }
      }
    }

    .upgrade-package-action {
      min-width: 125px;
      display: flex;
      justify-content: flex-end;
    }

    @media only screen and (max-width: 1280px) {
      width: 100%;
      flex-direction: column;
      gap: 16px;

      .upgrade-package-desc {
        width: 100%;
      }

      .upgrade-package-action {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
`;

export const StyledVoiceCloningDemoWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StyledVoiceCloningDemoTitle = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDemoCloningResults = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 144px;
  padding: 0 80px;

  @media only screen and (max-width: 868px) {
    padding: 0 40px;
    gap: 0px;
  }
`;

export const StyledDemoCloningResultItem = styled('div')`
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  height: 144px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  background-color: ${COLOR.whiteV2.default};
  border: 1px solid
    ${(props) => (props.isAudioPlaying ? COLOR.indigo[100] : COLOR.darkV2[16])};

  .avatar-wrapper {
    position: relative;

    .audio-icon {
      position: absolute;
      top: 20%;
      left: 25%;
      color: ${COLOR.whiteV2.default};
      width: 27px;
      height: 27px;
      display: none;
    }
  }

  .verified-icon {
    width: 20px;
    height: 20px;
  }

  .result-info-wrapper {
    width: 187px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;

    .info {
      text-align: center;
      width: 108px;
    }

    @media only screen and (max-width: 1280px) {
      width: 150px;
    }

    @media only screen and (max-width: 868px) {
      width: 100px;
      padding: 6px;
      box-sizing: border-box;

      .info {
        width: 80px;
      }
    }
  }

  .overlay {
    position: absolute;
    inset: -1px;
    z-index: 1;
    border-radius: 12px;

    &:hover {
      background-color: ${COLOR.indigo[8]};
    }
  }

  &:hover .audio-icon {
    display: block;
  }
`;

export const StyledArrowIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  .icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      width: 24px;
      height: 24px;
      color: ${COLOR.black[54]};
    }

    @media only screen and (max-width: 868px) {
      width: 32px;
      height: 32px;

      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const StyledStartVoicePopoverMenu = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  box-sizing: border-box;
  background: ${COLOR.white};
  ${(props) => props.width && `width: ${props.width}px`};
`;

export const StyledStartVoicePopoverItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease;
  gap: 8px;

  &:hover {
    background: ${COLOR.secondary[40]};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${COLOR.secondary[16]};
  }
`;
